import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrackerBatteryIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 27,
	height: 27,
	viewBox: "0 0 27 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_21_966",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 27,
		height: 27,
		children: /* @__PURE__ */ _jsx("rect", {
			x: 27,
			width: 27,
			height: 27,
			transform: "rotate(90 27 0)",
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_21_966)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8.87006 5.94956C8.87006 5.69212 8.95716 5.47631 9.13134 5.30212C9.30553 5.12794 9.52134 5.04084 9.77878 5.04084L11.5962 5.04084L11.5962 3.375L15.4038 3.375L15.4038 5.04084L17.2257 5.04084C17.4837 5.04084 17.6989 5.12794 17.8712 5.30212C18.0437 5.47631 18.1299 5.69212 18.1299 5.94956L18.1299 22.7163C18.1299 22.9737 18.0428 23.1895 17.8687 23.3637C17.6945 23.5379 17.4787 23.625 17.2212 23.625L9.78244 23.625C9.519 23.625 9.30112 23.5379 9.12881 23.3637C8.95631 23.1895 8.87006 22.9737 8.87006 22.7163L8.87006 5.94956Z",
			fill: "#2C3F81"
		})
	})]
});
export default SvgTrackerBatteryIcon;
